import { Spine } from '@esotericsoftware/spine-pixi-v7'
import * as PIXI from "pixi.js";
// import { Spine } from "pixi-spine";
import { globalData } from "./globalData";
import { config } from "./appConfig";
import { containers, controlJackpotWinSpine, gameAssets, rebootButton, restartGame, showAndDisablePlaybutton } from "./gameUI";
import { playChickenWinner } from "./soundManager";
import { incrementValue, tweenFadeAppear } from "./utility";
import {
  bigWin,
  COMMENDATION,
  grandJackpot,
  majorJackpot,
  megaWin,
  minorJackpot,
  setCommendationType,
  ultraWin,
} from "./commendation";
import { playCoinAnimation, stopCoinAnimation } from './coins';

export class winScreen {
  winTypes = Object.freeze({
    NONE: "NONE",
    NORMAL_WIN: "NORMAL_WIN",
    BIG_WIN: "BIG_WIN",
    MEGA_WIN: "MEGA_WIN",
    ULTRA_WIN: "ULTRA_WIN",
  });

  animationPrefix = "mega_win";
  winContainer = null;
  winSpine = null;
  listeners = []
  winAmountText = null;
  jackpotWinText = null;
  normalWin = null;
  winAmount = 0;
  count = false;
  normalWinContainer = null;

  minorJackpotSpine = null;
  majorJackpotSpine = null;
  grandJackpotSpine = null;

  majorJackpotText = null;
  minorJackpotText = null;
  grandJackpotText = null;

  jackpotSpine = null;
  normalWinValueText = null;
  loseMessage = null;
  losePop = false;
  loseClose = false;
  onClickRemove;

  backgroundBlur = null;

  constructor() {
    this.winContainer = new PIXI.Container();
    this.normalWinContainer = new PIXI.Container();

    this.backgroundBlur = new PIXI.Graphics();
    this.backgroundBlur.beginFill(0, 0.75);
    this.backgroundBlur.drawRect(
      config.logicalWidth / 2 - 750,
      config.logicalHeight / 2 - 1800,
      1500,
      3300
    );
    this.backgroundBlur.endFill();
    this.backgroundBlur.initialX = 0;
    this.backgroundBlur.initialY = 0;
    this.backgroundBlur.finalX = 0;
    this.backgroundBlur.finalY = 0;
    this.backgroundBlur.interactive = false;
    this.winContainer.addChild(this.backgroundBlur, containers.coinsContainer);
    // setUpCoinsContainer()
    this.backgroundBlur.visible = false;

    // this.minorJackpotSpine = new Spine(PIXI.Assets.get("jackpotSpine").spineData);
    this.minorJackpotSpine = Spine.from({ skeleton: "jackpotSpine", atlas: "jackpotAtlas" });
    this.minorJackpotSpine.x = config.logicalWidth / 2;
    this.minorJackpotSpine.y = config.logicalHeight / 2;
    this.minorJackpotSpine.state.timeScale = 1;
    this.minorJackpotSpine.interactive = false

    // this.majorJackpotSpine = new Spine(PIXI.Assets.get("jackpotSpine").spineData);
    this.majorJackpotSpine = Spine.from({ skeleton: "jackpotSpine", atlas: "jackpotAtlas" });
    this.majorJackpotSpine.x = config.logicalWidth / 2;
    this.majorJackpotSpine.y = config.logicalHeight / 2;
    this.majorJackpotSpine.state.timeScale = 1;
    this.majorJackpotSpine.interactive = false

    // this.grandJackpotSpine =  new Spine(PIXI.Assets.get("jackpotSpine").spineData);
    this.grandJackpotSpine = Spine.from({ skeleton: "jackpotSpine", atlas: "jackpotAtlas" });
    this.grandJackpotSpine.x = config.logicalWidth / 2;
    this.grandJackpotSpine.y = config.logicalHeight / 2;
    this.grandJackpotSpine.state.timeScale = 1;
    this.grandJackpotSpine.interactive = false

    // this.winSpine = new Spine(PIXI.Assets.get("winSpine").spineData);
    this.winSpine = Spine.from({ skeleton: "winSpine", atlas: "winAtlas" });
    this.winSpine.x = config.logicalWidth / 2;
    this.winSpine.y = config.logicalHeight / 2;
    //  this.winSpine.state.setAnimation(0, 'ultra_win_in', true);
    this.winSpine.state.timeScale = 1;
    this.winSpine.interactive = false;
    this.winContainer.addChild(
      this.winSpine,
      this.normalWinContainer,
      this.minorJackpotSpine,
      this.majorJackpotSpine,
      this.grandJackpotSpine
    );
    this.winSpine.visible = false;
    this.createWinText();
    this.createJackpotWinText();
    this.createNormalWin();

    this.createLoseText();

    //TODO:FOR TESTING ONLY
    // setTimeout(() => {
    //     globalData.winType = 'BIG_WIN'
    //     globalData.roundWinnings = 3000000
    //     this.showWin()
    // }, 2000);
    // setTimeout(() => {
    //     globalData.winType = 'NORMAL_WIN'
    //     globalData.roundWinnings = 10000
    //     this.showWin()
    // }, 3000);

    // setTimeout(() => {
    //     globalData.winType = 'MEGA_WIN'
    //     globalData.roundWinnings = 42300000
    //     this.showWin()
    // }, 12000);
    //  this.showLose()
  }

  createJackpotWinText() {
    this.minorJackpotText = new PIXI.BitmapText("0", {
      fontName: "normal-font",
      fontSize: 25,
      align: "center",
      letterSpacing: -10, //-85,
    });

    this.minorJackpotText.y = 265;
    this.minorJackpotText.x = 10;
    this.minorJackpotText.anchor.set(0.5);
    this.minorJackpotText.visible = false;

    //major
    this.majorJackpotText = new PIXI.BitmapText("0", {
      fontName: "normal-font",
      fontSize: 25,
      align: "center",
      letterSpacing: -10, //-85,
    });

    this.majorJackpotText.y = 265;
    this.majorJackpotText.x = 10;
    this.majorJackpotText.anchor.set(0.5);
    this.majorJackpotText.visible = false;

    //grand
    this.grandJackpotText = new PIXI.BitmapText("0", {
      fontName: "normal-font",
      fontSize: 25,
      align: "center",
      letterSpacing: -10, //-85,
    });

    this.grandJackpotText.y = 265;
    this.grandJackpotText.x = 10;
    this.grandJackpotText.anchor.set(0.5);
    this.grandJackpotText.visible = false;
  }

  onAdded() {
    this.decideWinType();
    // this.winSpine.visible = true;


    this.winAmountText.zIndex = 100;
    this.minorJackpotSpine.zIndex = 100;
    this.majorJackpotSpine.zIndex = 100;
    this.grandJackpotSpine.zIndex = 100;

    this.winSpine.addChild(this.winAmountText);
    this.minorJackpotSpine.addChild(this.minorJackpotText);
    this.majorJackpotSpine.addChild(this.majorJackpotText);
    this.grandJackpotSpine.addChild(this.grandJackpotText);

    this.minorJackpotText.zIndex = 500;
    this.majorJackpotText.zIndex = 500;
    this.grandJackpotText.zIndex = 500;

    this.minorJackpotSpine.sortableChildren = true;
    this.majorJackpotSpine.sortableChildren = true;
    this.grandJackpotSpine.sortableChildren = true;
    // setTimeout(() => {




    //     this.winAmountText.visible = true;
    // }, 400);
    // this.winSpine.state.setAnimation(0, this.animationPrefix + '_in', true);

    // this.winSpine.state.addListener({
    //     complete: (e) => {
    //         this.winSpine.state.setAnimation(0, this.animationPrefix + '_loop', true);
    //         this.winSpine.on("pointerdown", () => {
    //             this.onRemoved();
    //         })
    //     }
    // })
    // setTimeout(() => {
    //     this.winSpine.state.setAnimation(0, this.animationPrefix + '_loop', true);
    //     this.winSpine.on("pointerdown", () => {
    //         this.onRemoved();
    //         clearTimeout(this.onClickRemove);
    //     })
    // }, 600);
  }

  onRemoved() {
    // tweenFadeAppear(this.backgroundBlur, false);
    this.winAmountText.visible = false;
    if (!this.normalWin) {
      this.winSpine.state.setAnimation(0, this.animationPrefix + "_out", true);
      // this.winSpine.state.addListener({
      //     complete: (e) => {
      //         this.winSpine.visible = false;
      //         this.winSpine.interactive = false;
      //         this.normalWinHolder.interactive = false
      //         this.winSpine.removeChild(this.winAmountText);
      //         restartGame();
      //     }
      // })
      setTimeout(() => {
        this.winSpine.visible = false;
        this.winSpine.interactive = false;
        this.normalWinHolder.interactive = false;
        this.winSpine.removeChild(this.winAmountText);
        restartGame();
      }, 450);
    } else {
      stopCoinAnimation()
      this.normalWin = false;
      this.winSpine.interactive = false;
      this.normalWinHolder.interactive = false;
      this.normalWinValueText.visible = false;
      // this.normalWinHolder.removeChild(this.normalWinValueText);
      if (!globalData.jackpotMajorWin && !globalData.jackpotGrandWin && !globalData.jackpotMinorWin) {
        tweenFadeAppear(this.backgroundBlur, false);
        restartGame();
      } else {
        this.minorJackpotSpine.addChild(this.minorJackpotText);
        this.majorJackpotSpine.addChild(this.majorJackpotText);
        this.grandJackpotSpine.addChild(this.grandJackpotText);

        this.minorJackpotText.zIndex = 500;
        this.majorJackpotText.zIndex = 500;
        this.grandJackpotText.zIndex = 500;

        this.minorJackpotSpine.sortableChildren = true;
        this.majorJackpotSpine.sortableChildren = true;
        this.grandJackpotSpine.sortableChildren = true;
        this.jackpot()
      }


    }
    //  this.winAmount = 0;
  }

  decideWinType() {
    // if (globalData.winType === this.winTypes.NORMAL_WIN) {
    //     this.animationPrefix = 'big_win';
    // }
    this.winAmountText.interactive = false;
    if (globalData.winType === this.winTypes.BIG_WIN) {
      setCommendationType(COMMENDATION.BIG);
      bigWin(
        this.backgroundBlur,
        this.winAmountText,
        globalData.roundWinnings,
        this.winSpine
      );
      this.animationPrefix = "big_win";
      this.winAmountText.fontName = "bronze-font";
      // this.onClickRemove= setTimeout(() => {
      //     this.onRemoved();
      // }, 5000);
    } else if (globalData.winType === this.winTypes.MEGA_WIN) {
      setCommendationType(COMMENDATION.MEGA);
      megaWin(
        this.backgroundBlur,
        this.winAmountText,
        globalData.roundWinnings,
        this.winSpine
      );

      this.animationPrefix = "mega_win";
      this.winAmountText.fontName = "bronze-font";
      // this.onClickRemove= setTimeout(() => {
      //     this.onRemoved();
      // }, 5000);
    } else if (globalData.winType === this.winTypes.ULTRA_WIN) {
      setCommendationType(COMMENDATION.ULTRA);
      ultraWin(
        this.backgroundBlur,
        this.winAmountText,
        globalData.roundWinnings,
        this.winSpine
      );
      this.animationPrefix = "ultra_win";
      this.winAmountText.fontName = "bronze-font";
      // this.onClickRemove= setTimeout(() => {
      //     this.onRemoved();
      // }, 5000);
    }
  }


  jackpot() {
    if (globalData.jackpotMinorWin) {
      gameAssets.menubarButton.tint = 0x606060
      gameAssets.menubarButton.interactive = false
      globalData.jackpotMinorWin = false;
      controlJackpotWinSpine(0, true);
      setCommendationType(COMMENDATION.MINOR);
      this.minorJackpotText.fontName = "bronze-font";
      minorJackpot(
        this.minorJackpotSpine,
        globalData.jackpotMinorWinAmount,
        this.backgroundBlur,
        this.minorJackpotText
      );

    } else if (globalData.jackpotMajorWin) {
      gameAssets.menubarButton.tint = 0x606060
      gameAssets.menubarButton.interactive = false
      globalData.jackpotMajorWin = false;
      controlJackpotWinSpine(0, false);
      controlJackpotWinSpine(1, true);
      setCommendationType(COMMENDATION.MAJOR);
      this.majorJackpotText.fontName = "silver-font";
      majorJackpot(
        this.majorJackpotSpine,
        globalData.jackpotMajorWinAmount,
        this.backgroundBlur,
        this.majorJackpotText
      );
    } else if (globalData.jackpotGrandWin) {
      gameAssets.menubarButton.tint = 0x606060
      gameAssets.menubarButton.interactive = false
      globalData.jackpotGrandWin = false;
      controlJackpotWinSpine(1, false);
      controlJackpotWinSpine(2, true);
      setCommendationType(COMMENDATION.GRAND);
      this.grandJackpotText.fontName = "gold-font";
      grandJackpot(
        this.grandJackpotSpine,
        globalData.jackpotGrandWinAmount,
        this.backgroundBlur,
        this.grandJackpotText
      );
    }
  }

  createWinText() {
    // const style = new PIXI.TextStyle({
    //     dropShadow: false,
    //     dropShadowAngle: 0,
    //     dropShadowBlur: 0,
    //     dropShadowColor: 0,
    //     dropShadowDistance: 0,
    //     stroke: 0,
    //     strokeThickness: 0,
    //     fill: '#ffffff',
    //     fontFamily: 'Arial',
    //     fontSize: 140,
    //     fontWeight: '1000',
    //     align: 'center'
    // });

    // const go = new PIXI.BitmapText("GO!", {
    //     fontName: 'normal-font',
    //     fontSize: 40,
    //     align: 'center',
    //     letterSpacing: -10, //-85,
    // });

    this.winAmountText = new PIXI.BitmapText("0", {
      fontName: "normal-font",
      fontSize: 36,
      align: "center",
      letterSpacing: -10, //-85,
    });

    this.winAmountText.y = 255;
    this.winAmountText.x = 10;
    this.winAmountText.anchor.set(0.5);
    this.winAmountText.visible = true;
  }

  showWin() {
    playChickenWinner();
    if (globalData.winType === this.winTypes.NORMAL_WIN) {
      // this.winAmountText.letterSpacing = 0;
      tweenFadeAppear(this.backgroundBlur, true);
      //  restartGame();
      this.startNormalWin();
      setTimeout(() => {
        rebootButton();
      }, 350);
      //this.normalWin = true;
      setTimeout(() => {
        rebootButton();
      }, 350);
      return;
    }
    // this.count = true;
    // this.winAmountText.text = this.winAmount.toString();
    // this.winAmountText.letterSpacing = -50;
    this.onAdded();
    setTimeout(() => {
      rebootButton();
    }, 350);
  }

  createLoseText() {
    this.loseMessage = new PIXI.BitmapText("Go\nAgain!", {
      fontName: "normal-font",
      fontSize: 0,
      align: "center",
      letterSpacing: -10,
    });
    this.loseMessage.anchor.set(0.5);
    this.loseMessage.x = config.logicalWidth / 2 + 10;
    this.loseMessage.y = config.logicalHeight * 0.66 - 5;
    this.winContainer.addChild(this.loseMessage);

    // this.loseMessage.on("pointerdown", () => {
    //   this.losePop = false;
    //   this.loseClose = true;
    //   this.loseEnd();
    //   clearTimeout(this.onClickRemove);
    // });

    const style = new PIXI.TextStyle({
      dropShadow: true,
      dropShadowAngle: 1,
      dropShadowBlur: 0,
      dropShadowColor: 0,
      dropShadowDistance: 5,
      stroke: 0,
      strokeThickness: 6,
      fill: "#fff000",
      fontFamily: "Arial",
      fontSize: 70,
      fontWeight: "700",
      align: "center",
    });

    const loseMessageChild = new PIXI.Text("Prizes out of reach!", style);
    loseMessageChild.y = 335;
    loseMessageChild.x = 0;
    loseMessageChild.anchor.set(0.5);

    this.loseMessage.addChild(loseMessageChild);
    this.loseMessage.children[0].visible = false;
  }

  showLose() {
    tweenFadeAppear(this.backgroundBlur, true);
    this.loseMessage.children[0].visible = true;
    this.losePop = true;

    this.onClickRemove = setTimeout(() => {
      this.losePop = false;
      this.loseClose = true;
      this.loseEnd();
    }, 5000);

    this.winContainer.interactive = true;
    const onClickListener = () => {
      clearTimeout(this.onClickRemove);
      this.loseEnd();
    };
    this.winContainer.on('pointerdown', onClickListener);
    this.listeners.push(onClickListener);

    setTimeout(() => {
      rebootButton();
    }, 350);

    // if (startText) {
    //     this.loseMessage.text = "Lets'\nGO!"
    //     this.loseMessage.children[0].text = "Choose bets & Rounds"
    // }
    // else {
    //     this.loseMessage.text = "Go\nAgain!"
    //     this.loseMessage.children[0].text = "Prizes out of reach!"
    // }
  }

  loseEnd() {
    this.loseMessage.children[0].visible = false;
    this.loseClose = false;
    this.losePop = false;
    this.winContainer.interactive = false;
    this.loseMessage.fontSize = 0;
    if (!globalData.jackpotMajorWin && !globalData.jackpotGrandWin && !globalData.jackpotMinorWin) {
      this.listeners.forEach((listener) => {
        this.winContainer.off("pointerdown", listener);
      });
      tweenFadeAppear(this.backgroundBlur, false);
      restartGame();
    } else {
      this.listeners.forEach((listener) => {
        this.winContainer.off("pointerdown", listener);
      });
      this.minorJackpotSpine.addChild(this.minorJackpotText);
      this.majorJackpotSpine.addChild(this.majorJackpotText);
      this.grandJackpotSpine.addChild(this.grandJackpotText);

      this.minorJackpotText.zIndex = 500;
      this.majorJackpotText.zIndex = 500;
      this.grandJackpotText.zIndex = 500;

      this.minorJackpotSpine.sortableChildren = true;
      this.majorJackpotSpine.sortableChildren = true;
      this.grandJackpotSpine.sortableChildren = true;
      this.jackpot()
    }
  }

  update(delta) {
    // if (this.winAmount < globalData.roundWinnings && this.count) {
    //     if (globalData.roundWinnings > 100) {
    //         this.winAmount += Math.round(globalData.roundWinnings / 100 * delta);
    //     }
    //     else {
    //         this.winAmount = globalData.roundWinnings;
    //     }
    //     this.winAmountText.text = this.winAmount

    // } else if (this.count) {
    //     this.winAmount = globalData.roundWinnings;
    //     this.winAmountText.text = this.winAmount
    //     this.count = false;
    //     this.normalWinHolder.interactive = true
    //     this.winSpine.interactive = true;
    //     this.winAmount = 0;
    // }
    if (this.normalWin) {
      //   this.normalWinBg.angle += delta;
      this.normalWinSparkle.angle -= delta;
      if (this.normalWinHolder.scale.x < 1 && this.popUpNormalWin) {
        this.normalWinHolder.scale.x += delta * 0.05;
        this.normalWinHolder.scale.y += delta * 0.05;
      } else if (this.popUpNormalWin) {
        this.normalWinHolder.scale.x = 1;
        this.normalWinHolder.scale.y = 1;
        this.popUpNormalWin = false;
      }
    } else if (
      !this.normalWin &&
      !this.popUpNormalWin &&
      this.normalWinHolder.scale.x > 0
    ) {
      this.normalWinHolder.scale.x -= delta * 0.1;
      this.normalWinHolder.scale.y -= delta * 0.1;
    } else if (!this.popUpNormalWin) {
      this.normalWinHolder.scale.x = 0;
      this.normalWinHolder.scale.y = 0;
      this.popUpNormalWin = true;
    }

    if (this.loseMessage.fontSize <= 40 && this.losePop) {
      this.loseMessage.fontSize += delta * 2;
      if (this.loseMessage >= 40 && this.losePop) {
        this.losePop = false;
        this.loseMessage.fontSize = 40;
      }
    } else if (this.loseMessage.fontSize >= 0 && this.loseClose) {
      this.loseMessage.fontSize -= delta * 3;
      if (this.loseMessage <= 0 && this.loseClose) {
        this.loseClose = false;
        this.loseMessage.fontSize = 0;
      }
    }
  }
  normalWinSparkle = null;
  //   normalWinBg = null;
  normalWinTextContainer = null;
  normalWinText = null;
  normalWin = false;
  popUpNormalWin = true;
  defaultWidth = 0;
  defaultHeight = 0;

  createNormalWin() {
    //  this.normalWinContainer.scale.set(0)

    this.normalWinHolder = new PIXI.Sprite(PIXI.Assets.get("normalWinSparkle"));
    this.normalWinHolder.x = config.logicalWidth / 2;
    this.normalWinHolder.y = config.logicalHeight / 2;
    this.normalWinHolder.anchor.set(0.5);
    this.normalWinContainer.addChild(this.normalWinHolder);

    this.normalWinHolder.scale.set(0);

    // this.normalWinBg = new PIXI.Sprite(PIXI.Assets.get("normalWinBg"));
    // this.normalWinBg.x = 0;
    // this.normalWinBg.y = 0;
    // this.normalWinBg.anchor.set(0.5);
    // this.normalWinHolder.addChild(this.normalWinBg);

    this.normalWinSparkle = new PIXI.Sprite(
      PIXI.Assets.get("normalWinSparkle")
    );
    this.normalWinSparkle.x = 0;
    this.normalWinSparkle.y = 0;
    this.normalWinSparkle.anchor.set(0.5);
    this.normalWinHolder.addChild(this.normalWinSparkle);

    this.normalWinTextContainer = new PIXI.Sprite(
      PIXI.Assets.get("normalWinContainer")
    );
    this.normalWinTextContainer.x = 0;
    this.normalWinTextContainer.y = 0 + 270;
    this.normalWinTextContainer.anchor.set(0.5);
    this.normalWinHolder.addChild(this.normalWinTextContainer);
    // this.normalWinHolder.addChild(this.winAmountText);

    this.normalWinText = new PIXI.Sprite(PIXI.Assets.get("normalWinText"));
    this.normalWinText.x = 0;
    this.normalWinText.y = 0;
    this.normalWinText.anchor.set(0.5);
    this.normalWinHolder.addChild(this.normalWinText);
    this.normalWinHolder.on("pointerdown", () => {
      this.onRemoved();
      clearTimeout(this.onClickRemove);
    });


    this.normalWinValueText = new PIXI.BitmapText("0", {
      fontName: "normal-font",
      fontSize: 35,
      align: "center",
      letterSpacing: -10, //-85,
    });

    this.normalWinValueText.y = 255;
    this.normalWinValueText.x = 10;
    this.normalWinValueText.anchor.set(0.5);
    this.normalWinValueText.visible = true;
    this.normalWinHolder.addChild(this.normalWinValueText);
  }

  startNormalWin() {
    playCoinAnimation(0)
    this.normalWinValueText.fontName = "normal-font"
    this.normalWinValueText.visible = true;

    this.normalWinHolder.interactive = true;
    this.normalWinValueText.text = 0;
    incrementValue(this.normalWinValueText, globalData.roundWinnings, 8)
    this.normalWin = true;
    this.popUpNormalWin = true;

    // this.count = true;
    this.onClickRemove = setTimeout(() => {
      this.onRemoved();
    }, 5000);
  }
}
